import {CloseButton} from '../../Buttons';

/**
 * @deprecated use components/Buttons/CloseButton instead
 */
export default CloseButton;
